module.exports = __webpack_public_path__ + "img/nj.eb9fce93.svg";